<template>
    <div class="login">
        <img class="logo" :src="logo" />
        <h2>{{ title }}</h2>
        <form>
            <slot name="form"></slot>
            <div v-if="!formHidden">
                <button v-for="button in buttons" class="button" :key="button.text" :disabled="button.disabled"
                    :type="button.type" @click.prevent.stop="submit(button.event)">
                    <span>{{ button.text }}</span>
                </button>
            </div>
            <router-link v-for="goToRoute in goToRoutes" class="link" :key="goToRoute.text" :to="goToRoute.route"> {{
                goToRoute.text }} </router-link>
        </form>
        <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    </div>
</template>

<script>
export default {
    name: 'LoginContainer',
    props: {
        logo: {
            type: String,
        },
        buttons: {
            type: Array,
        },
        formHidden: {
            type: Boolean,
            default: false,
        },
        disabled: {
            default: null,
        },
        goToRoutes: {
            default: null,
        },
        errorMessage: {
            type: String,
        },
        title: {
            type: String,
        },
    },
    data() {
        return {
        }
    },
    emits: ["submit"],
    methods: {
        submit(event) {
            this.$emit('submit', event)
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../assets/utilities/_variables.scss';

.login {
    background: var(--card-bg);
    padding: 5em;
    width: auto;
    border-radius: 10px;

    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;

    .logo {
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 50px;
        max-width: 200px;
        width: 200px;
    }

    .button {
        background-color: var(--highlight-color);
        color: var(--highlight-bg-text-color);
        border: 0;
        border-radius: 5px;
        margin: 10px 0 10px 0;
        padding: 10px;
        font-size: large;
        width: 100%;
        cursor: pointer;
        transition: .1s ease-out box-shadow;
        outline: none;

        &:hover,
        &:focus {
            box-shadow: 0 0 16px 0 var(--highlight-color);
        }
    }

    .link {
        margin-left: 10px;

        &:visited {
            text-decoration: none;
            color: var(--text-color);
        }

        &:link {
            text-decoration: none;
        }
    }

    .error {
        color: var(--error-color);
        text-transform: uppercase;
        font-weight: bold;
    }
}
</style>
